module.exports = __webpack_public_path__ + "static/media/roi-depression.fde6a612.png";